import * as React from "react";
import "../App.css";
import "@aws-amplify/ui-react/styles.css";
import { useContext } from "react";

import EnumRadioSelector from "../components/EnumRadioSelector";
import EventEnumRadioSelector from "../components/EventEnumRadioSelector";
import { ApplicationContext } from "../contexts/applicationcontext";
import { SelectedCharacteristicsContext } from "../contexts/selectedcharacteristicscontext";


export default function CharacteristicsSelector() {
  var characteristics = [];
  const { selectedCharacteristics, setSelectedCharacteristics } = useContext(
    SelectedCharacteristicsContext
  );
  const { enumMap } = useContext(ApplicationContext);
  console.log(
    `SELECTEDCHARACTERISTICS....: ${JSON.stringify(selectedCharacteristics)}`
  );
  characteristics = selectedCharacteristics;

  function handleEvent(event, enumValue, charsToDisplay) {
    console.log(
      `EERS, ${event}, ${enumValue}, ${JSON.stringify(charsToDisplay)}`
    );
    console.log(`FIRST CHAR: ${charsToDisplay[0].name}`);
    characteristics = [];
    charsToDisplay.forEach((element) => {
      characteristics.push(element.name);
    });
    setSelectedCharacteristics(characteristics);
    console.log(`C read: ${JSON.stringify(characteristics)}`);
    console.log(`SC to go to: ${JSON.stringify(selectedCharacteristics)}`);
  }


  return (
    <>
      <EventEnumRadioSelector
        disabled={true}
        enumType="Dataset"
        enumMap={enumMap}
        initValue={"HOP"}
        selectorSize={50}
        onEvent={handleEvent}
      />
      {characteristics.map((characteristic) => (
        //<Typography>{enumContentMap.get(characteristic}</Typography>
        <EnumRadioSelector
          enumType={characteristic}
          enumMap={enumMap}
          selectorSize={50}
          //enumType, enumList, enumMap , selectorSize, selectAll
        />
      ))}
      <br />
    </>
  );
}
